import { render } from "./BuyPage.vue?vue&type=template&id=51ca5367&scoped=true"
import script from "./BuyPage.vue?vue&type=script&lang=js"
export * from "./BuyPage.vue?vue&type=script&lang=js"

import "./BuyPage.vue?vue&type=style&index=0&id=51ca5367&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ca5367"]])

export default __exports__